(function () {
  let swiperFeaturedProducts;
  const updateSliderPosition = (section) => {
    const parentContainer = section.querySelector(".featured-products-main");
    const imagesContainer = section.querySelector(".featured-products-images");
    const firstSlideImage = section.querySelector(
      ".card-small-image-link-wrapper"
    );
    if (!firstSlideImage || !parentContainer || !imagesContainer) return;
    parentContainer.style.paddingTop = "";
    parentContainer.style.paddingBottom = "";
    imagesContainer.style.margin = "auto 0";
    if (window.innerWidth < 990) {
      return;
    }
    const parentRect = parentContainer.getBoundingClientRect();
    const imagesContainerRect = imagesContainer.getBoundingClientRect();
    const imageRect = firstSlideImage.getBoundingClientRect();
    const currentOffset = imageRect.top - parentRect.top;
    const targetOffset = parentRect.bottom - imageRect.bottom;
    const extraPadding = targetOffset - currentOffset;
    if (imagesContainerRect.height < parentRect.height) {
      const offset =
        currentOffset + imageRect.height / 2 - imagesContainerRect.height / 2;
      if (offset < 0) {
        imagesContainer.style.margin = "0";
        parentContainer.style.paddingTop = `${-offset}px`;
        return;
      }
      imagesContainer.style.margin = `${offset}px 0 0 0`;
      return;
    }
    if (extraPadding < 0) {
      parentContainer.style.paddingBottom = `${-extraPadding}px`;
      return;
    }
    parentContainer.style.paddingTop = `${extraPadding}px`;
  };
  const updateNavPosition = (section) => {
    const nav = section.querySelector(".featured-products-nav");
    if (!nav) return;
    const firstSlide = section.querySelector(
      ".featured-products-slider-slide__product"
    );
    if (!firstSlide) return;
    const imgWrapper = firstSlide.querySelector(
      ".card-small-image-link-wrapper"
    );
    if (!imgWrapper) return;
    const swiperEl = section.querySelector(".featured-products-slider");
    const swiperRect = swiperEl.getBoundingClientRect();
    const imgRect = imgWrapper.getBoundingClientRect();
    const offsetTop = imgRect.top - swiperRect.top;
    const centerY = offsetTop + imgRect.height / 2;
    nav.style.top = `${centerY}px`;
  };
  const initSlider = (section) => {
    if (!!swiperFeaturedProducts) {
      return;
    }
    const swiperEl = section.querySelector(".featured-products-slider");
    if (!swiperEl) return;
    const prevBtn = section.querySelector(
      ".featured-products-nav-button--prev"
    );
    const nextBtn = section.querySelector(
      ".featured-products-nav-button--next"
    );
    const correspondingImages = section.querySelectorAll("[data-img-block-id]");
    const correspondingImagesMap = new Map(
      Array.from(correspondingImages, (el) => [el.dataset.imgBlockId, el])
    );
    const sliderOptions = {
      slidesPerView: 1,
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      spaceBetween: 16,
      speed: 500,
      allowTouchMove: true,
      loop: true,
      mousewheel: {
        forceToAxis: true,
      },
      a11y: {
        scrollOnFocus: false,
      },
      preventClicks: true,
      watchOverflow: true,
      navigation:
        nextBtn && prevBtn
          ? {
              nextEl: nextBtn,
              prevEl: prevBtn,
              disabledClass: "swiper-button-disabled",
            }
          : false,
      on: {
        slideChange: function (e) {
          const currentSlide = e.slides[e.activeIndex];
          const correspondingImage = correspondingImagesMap.get(
            currentSlide.dataset.blockId
          );
          if (correspondingImage) {
            Array.from(correspondingImages).forEach((img) => {
              img.classList.remove("active");
            });
            correspondingImage.classList.add("active");
          }
        },
        afterInit: function () {
          updateSliderPosition(section);
          updateNavPosition(section);
        },
      },
    };
    swiperFeaturedProducts = new Swiper(swiperEl, sliderOptions);
    const nav = section.querySelector(".featured-products-nav");
    if (nav) {
      nav.classList.add("featured-products-nav--visible");
    }
  };
  const initFeaturedProducts = (section) => {
    if (!section || !section?.classList.contains("featured-products-section"))
      return;
    let sectionWidth = section.getBoundingClientRect().width;
    initSlider(section);
    const sectionResizeObserver = new ResizeObserver((entries) => {
      const [entry] = entries;
      if (entry.contentRect.width != sectionWidth) {
        updateSliderPosition(section);
        updateNavPosition(section);
        sectionWidth = entry.contentRect.width;
      }
    });
    sectionResizeObserver.observe(section);
  };
  const initHeadingAnimation = (section) => {
    if (!section || !section?.classList.contains("featured-products-section")) {
      return;
    }
    const enableAnimation = section.querySelector(
      "[data-enable-header-animation]"
    );
    if (!enableAnimation) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const section = entry.target;
            section.classList.add("anim-active");
            observer.unobserve(section);
          }
        });
      },
      {
        threshold: 0,
        rootMargin: "0px 0px -25% 0px",
      }
    );
    observer.observe(section);
  };
  initFeaturedProducts(document.currentScript.parentElement);
  initHeadingAnimation(document.currentScript.parentElement);
  document.addEventListener("shopify:section:load", function (event) {
    initFeaturedProducts(event.target);
    initHeadingAnimation(event.target);
  });
})();
